<template lang="html">
    <div class="flex-col dashboard-container">
      <div class="breadCrumb-container">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{$t('message.dashboard')}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="flex-row total-container">
         <div class="flex-row header-double">
          <div class="flex-col total-common">
            <div class="title-common">{{$t('message.totalTerminal')}}</div>
            <div class="total-body">{{terminalTotalNum}}</div>
          </div>
          <div class="flex-col total-common">
            <div class="title-common">{{$t('message.activeTerminal')}}</div>
            <div class="total-body">{{terminalActivedNum}}</div>
          </div>
          <div class="flex-col total-common" style="margin-right: 0">
            <div class="title-common">{{$t('message.totalApp')}}</div>
            <div class="total-body">{{appTotalNum}}</div>
          </div>
        </div>
        <div class="flex-row header-double">
          <div class="flex-col total-common">
            <div class="title-common">{{$t('message.totalAppDownload')}}</div>
            <div class="total-body">{{appDownloadsNum}}</div>
          </div>
          <div class="flex-col total-common">
            <div class="title-common">{{$t('message.downloadUper')}}</div>
            <div class="total-body">{{downloadsTask}}</div>
          </div>
          <div class="flex-col total-common" style="margin-right: 0">
            <div class="title-common">{{$t('message.todayAppDownload')}}</div>
            <div class="total-body">{{appDownloadsToday}}</div>
          </div>
        </div>
      </div>
      <div class="flex-row middle-container">
        <div class="flex-col middle-item">
          <div class="title-common-left">{{$t('message.downloadStatistics')}}</div>
          <template  v-if="taskList == 0">
            <div class="flex-row">
              <div class="flex-col echart-item">
                <div class="no-tip-con">
                  <img src="static/img/no-taskList.jpg">
                </div>
                <div class="noTip-txt-con">No download tasks yet</div>
              </div>
            </div>
          </template>
            <div class="flex-row" v-show="taskList.length > 0">
              <div class="flex-col echart-item">
                <div class="echart-con" id="echart1"></div>
                <div class="time-con">{{time1}}</div>
              </div>
             <div class="flex-col echart-item">
                <div class="echart-con" id="echart2"></div>
                <div class="time-con">{{time2}}</div>
              </div>
              <div class="flex-col echart-item">
                <div class="echart-con" id="echart3"></div>
                <div class="time-con">{{time3}}</div>
              </div>
            </div>
            <div class="flex-row chart-icon-tip">
              <div><span class="echart-icon-color1"></span>{{$t('message.notDownload')}}</div>
              <div><span class="echart-icon-color2"></span>{{$t('message.toBeInstalled')}}</div>
              <div><span class="echart-icon-color3"></span>{{$t('message.installed')}}</div>
            </div>
        </div>
        <div class="flex-col middle-item">
          <div class="title-common-left">{{$t('message.newApp')}}</div>
          <template v-if="newAppList == 0">
            <div class="flex-row">
              <div class="flex-col echart-item">
                <div class="no-tip-con">
                  <img src="static/img/no-newApp.jpg">
                </div>
                <div class="noTip-txt-con">No apps yet</div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="flex-row newApp-contain">
              <div class="flex-col newApp-item" v-for="newAppItem in newAppList">
                <div class="flex-col app-icon">
                  <img :src="newAppItem.logo">
                  <div class="app-version">{{newAppItem.version}}</div>
                </div>
                  <div class="app-name">{{newAppItem.name}}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="flex-row footer-container">
        <div class="flex-col footer-item">
           <div class="title-common-left">{{$t('message.monthlyDownload')}}</div>
          <div class="echart5" id="monthEchart"></div>
        </div>
        <div class="flex-col footer-item">
            <div class="title-common-left app-rank">
                <span>{{$t('message.topApp')}}</span>
                <span>{{$t('message.downloads')}}</span>
            </div>

          <template  v-if="topList == 0">
            <div class="flex-row">
              <div class="flex-col echart-item">
                <div class="no-tableTop-con">
                  <img src="static/img/no-appTop.jpg">
                </div>
                <div class="noTip-txt-con">No apps yet</div>
              </div>
            </div>
          </template>
          <template v-else>
            <el-table :data="topList" :show-header="false" height="25vh" style="font-size: .8vw; width:98%">
              <el-table-column align="left">
                <template slot-scope="scope">
                  <template v-if="scope.$index === 0"><span class="red">No.{{scope.$index+1}}</span></template>
                  <template v-if="scope.$index === 1"><span class="orange">No.{{scope.$index+1}}</span></template>
                  <template v-if="scope.$index === 2"><span class="blue">No.{{scope.$index+1}}</span></template>
                  <template v-if="scope.$index > 2"><span class="black">No.{{scope.$index+1}}</span></template>
                </template>
              </el-table-column>
              <el-table-column  prop="logo" label="logo" width="50">
                <template slot-scope="scope">
                  <img :src="scope.row.logo" width="30" height="30"/>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="name" width="200" align="left"/>
              <el-table-column prop="version" label="version" width="100" align="left"/>
              <el-table-column
                prop="downloadsNum"
                width="" align="right">
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    name: 'Dashboard',
    data() {
      return {
        timer:0,
        terminalActivedNum : '',
        terminalTotalNum : '',
        appDownloadsNum : '',
        appTotalNum : '',
        appDownloadsToday : '',
        downloadsTask : '',
        time1:'',
        time2:'',
        time3:'',
        newAppList :[],
        topList : [],
        taskList : [],
        months : [],
        daysList:[],
        totalList:[],
        fontClass:['red','orange','blue','black']
      }
    },
    mounted() {
      this.queryDashboard();
      if(this.timer){
        clearInterval(this.timer);
      }else{
        this.timer=setInterval(() => {
          this.queryDashboard();
          console.log(1000);
        },300000);
      }
    },
    destroyed(){
      clearInterval(this.timer)
    },
    methods: {
      showPie(chartName,dataList,type,color){
        var circleId = this.$echarts.init(document.getElementById(chartName));
        let option;
      /*  if(type === 0){*/
          option={
            tooltip: {
              trigger: 'item',
              formatter: "{a} <br/>{b}: {c} ({d}%)"
            },
            grid:{
              y:20,
              y2:50
            },
         /*   color:['#188df0','#4fc8ff','#16b7ff'],*/
            color:color,
            tooltip: {
              confine: true
            },
            series: [
              {
                /*name:'Source',*/
                type:'pie',
                radius : '70%',
                center: ['50%', '54%'],/*饼图的放置位置*/
                avoidLabelOverlap: true,
                label: {   /* 显示的标签*/
                  normal: {
                    show: true,
                    position: 'left',
                    textStyle: {
                      fontSize: '12',
                      fontWeight: 'normal',
                      color:'#fff'
                    }
                  },
                  emphasis: {
                    show: true,
                    textStyle: {
                      fontSize: '20',
                      fontWeight: 'bold'
                    },
                    position: 'center'
                  }
                },
                labelLine: {  /*数据引出来的线*/
                  normal: {
                    show: false,
                    length:0
                  }
                },
                data: dataList
              }
            ]
          };
        /*}else if(type === 1){
          option={
            tooltip: {
              trigger: 'item',
              formatter: "{a} <br/>{b}: {c} ({d}%)"
            },
            grid:{
              y:20,
              y2:50
            },
            color:['#188df0','#4fc8ff','#16b7ff'],
          /!*  color:['#d04a44','#78c9df','#6b96d6','#2a80c8'],*!/
            series: [
              {
                name:'Source',
                type:'pie',
                radius : '55%',
                center: ['50%', '60%'],
                avoidLabelOverlap: true,
                label: {
                  normal: {
                    show: true,
                    position: 'left',
                    textStyle: {
                      fontSize: '12',
                      fontWeight: 'normal',
                      color:'#fff'
                    }
                  },
                  emphasis: {
                    show: true,
                    textStyle: {
                      fontSize: '20',
                      fontWeight: 'bold'
                    },
                    position: 'center'
                  }
                },
                labelLine: {
                  normal: {
                    show: false,
                    length:0
                  }
                },
                data: dataList
              }
            ]
          };
        }*/
        circleId.setOption(option);
      },
      queryDashboard() {
        const that = this;

        this.$axios({
            method: 'get',
            url: '/marketplace/dashboard',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.terminalActivedNum = response.data.terminalActivedNum;
            that.terminalTotalNum = response.data.terminalTotalNum;
            that.appDownloadsNum = response.data.appDownloadsNum;
            that.appTotalNum = response.data.appTotalNum;
            that.appDownloadsToday = response.data.appDownloadsToday;
            that.downloadsTask = response.data.downloadsTask;
            if(response.data.newAppList) {
              that.newAppList = response.data.newAppList;
            }
            if(response.data.toplist) {
              that.topList = response.data.toplist;
            }
            let daysList=[];
            let totalList=[];
            for(let i=0;i<response.data.days.length;i++){
              daysList.push(response.data.days[i].day);
              totalList.push(response.data.days[i].total);
            }
            that.showMonthLine(daysList,totalList);
            if(response.data.taskList){
              that.taskList = response.data.taskList;
              that.showPie('echart1',that.taskList[0].pie,0,that.taskList[0].color);
              that.time1=that.taskList[0].ctime;
              that.showPie('echart2',that.taskList[1].pie,1,that.taskList[1].color);
              that.time2=that.taskList[1].ctime;
              that.showPie('echart3',that.taskList[2].pie,0,that.taskList[2].color);
              that.time3=that.taskList[2].ctime;
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      showMonthLine (daysList,totalList){
        var monthlyEchart = this.$echarts.init(document.getElementById('monthEchart'));
        let yMax = Math.max(...totalList);
        let dataShadow = [];

        for (let i = 0; i < totalList.length; i++) {
          dataShadow.push(yMax);
        }
        const opt = {
          grid:{
            y:20,
            y2:50,
            x:70
          },
          xAxis: {
            data:daysList,
            /*data:daysList,*/
            axisLabel: {
              inside: false,
              textStyle: {
                color: '#8e8e8e'
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            z: 10
          },
          yAxis: {
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#999'
              }
            }
          },
          dataZoom: [
            {
              type: 'inside'
            }
          ],
          series: [
               {
                   type: 'bar',
                   itemStyle: {
                     normal: {color: 'rgba(0,0,0,0.05)'}
                   },
                   barGap:'-100%',
                   barCategoryGap:'40%',
                   data: dataShadow,
                   animation: false
                 },
            {
              type: 'bar',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset: 0, color: '#83bff6'},
                      {offset: 0.5, color: '#188df0'},
                      {offset: 1, color: '#188df0'}
                    ]
                  )
                },
                emphasis: {
                  color: new this.$echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset: 0, color: '#2378f7'},
                      {offset: 0.7, color: '#2378f7'},
                      {offset: 1, color: '#83bff6'}
                    ]
                  )
                }
              },
             data: totalList
              /*data:totalList*/
            }
          ]
        };
        monthlyEchart.setOption(opt);
      }
    }
}
</script>

<style scope>
  .dashboard-container {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    min-width: 1060px;
    overflow: auto;
  }
  .flex-row{
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
  }
  .flex-col {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
  }
  .breadCrumb-container {
    width:100%;
    padding-left: 40px;
    margin-bottom: 20px;
  }
  .total-container,.middle-container,.footer-container {
    width:100%;
    justify-content:space-around!important;
    padding:10px 30px
  }
 /* .footer-container {
    height:25vh;
    overflow: auto;
  }*/
  .total-common {
    background: #ffffff;
    padding:1vw .8vw;
    line-height: 20px;
    text-align: center;
    box-shadow: 1px 1px 1px 1px rgba(170, 170, 170, 1);
    border: 1px solid rgba(255, 255, 255, 0);
    flex: 1;
    margin-right: 10px;
  }
  .title-common,.title-common-left {
    height: 33px;
    line-height: 29px;
    color: rgba(142, 142, 142, 1);
    font-size: 1.1vw;
    font-family: Roboto;
  }
  .title-common {
    text-align: center;
  }
  .title-common-left {
    text-align: left;
  }
  .total-body {
    height: 70px;
    line-height: 70px;
    color: rgba(16, 16, 16, 1);
    font-size: 2vw;
    text-align: center;
    font-weight: bold;
  }
  .header-double {
    flex: 1;
    justify-content: space-between;
  }
  .middle-item,.footer-item {
    line-height: 20px;
    text-align: center;
    box-shadow: 1px 1px 1px 1px rgba(170, 170, 170, 1);
    border: 1px solid rgba(255, 255, 255, 0);
    flex: 1;
    background: #ffffff;
    padding:20px;
  }
  .middle-item:first-child,.footer-item:first-child,.header-double:first-child {
    margin-right: 20px;
  }
  .echart-con {
    width: 10vw;
    height: 13vh;
  }
  .table-con {
    height:30vh;
    overflow: auto;
  }
  .time-con {
    /*height: 33px;
    line-height: 29px;
    color: rgba(142, 142, 142, 1);
    font-size: 1vw;
    text-align: center;
    font-family: Roboto;
    padding-top: 10px;*/
    justify-content:space-around!important;
    color: rgba(142, 142, 142, 1);
    padding-top: 10px;
    font-size: 0.5vw;
  }
  .noTip-txt-con {
    height: 33px;
    line-height: 29px;
    color: rgba(142, 142, 142, 1);
    font-size: 1.1vw;
    text-align: center;
    font-family: Roboto;
  }
  .echart-item {
    flex: 1;
    align-items: center;
  }
  .newApp-contain {
    justify-content:space-around!important;
    padding-top: 10px;
  }
  .newApp-item {
    align-items: center;
    margin-top: 1vh;
    flex:1;
  }
  .app-orderNo {
    font-size: 1.2vw;
    font-weight: bold;
  }
  .red {
    color:#E51C23;
  }
  .orange {
    color:#ff9800;
  }
  .blue {
    color:#00A0E8;
  }
  .black {
    color: #101010;
  }
  .app-icon {
    width: 7vw;
    height: 10vh;
    border-radius: 10px;
    align-items: center;
    justify-content: center;
  }
  .app-icon img {
    width:4vw;
    border-radius: 10px;
  }
  .app-name {
    height: 33px;
    line-height: 29px;
    color: rgba(142, 142, 142, 1);
    font-size: 1vw;
    text-align: center;
    font-family: Roboto;
    padding-top: 20px;
  }
  .app-version {
    height: 33px;
    line-height: 29px;
    color: rgba(142, 142, 142, 1);
    font-size: 1vw;
    text-align: center;
    font-family: Roboto;
    padding-top: 15px;
  }
  .top-app-name {
    line-height: 29px;
    color: rgba(142, 142, 142, 1);
    font-size: 1.2vw;
    text-align: center;
    font-family: Roboto;
  }
  .footer-item {
    flex: 1;
  }
  .tr-item {
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #8E8E8E;
    padding: 10px 0;
    margin-bottom: 10px;
    font-size: 18px;
  }
  .tr-item:last-child {
    border-bottom: none;
  }
  .top-app-container {
    align-items: center;
    height: 60px;
  }
  .top-app-container img {
    width: 50px;
    height: 50px;
    margin-right: 20px;
    border-radius: 10px;
  }
  #monthEchart {
    width:100%;
    height: 25vh;
  }
  .no-tip-con {
    width:12vw;
  }
  .no-tip-con img {
    width:100%;
    height: 100%;
  }
  .no-tableTop-con {
    width:12vw;
  }
  .no-tableTop-con img{
    width:100%;
    height: 100%;
  }
  .chart-icon-tip {
    padding: 10px;
    justify-content: space-around;
    color: #606061;
    font-size: .9vw;
  }
  .echart-icon-color1 {
    display:inline-block;
    background:#d04a44;
    width: 15px;
    height: 15px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 50%;
  }
  .echart-icon-color2 {
    display:inline-block;
    background:#78c9df;
    width: 15px;
    height: 15px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 50%;
  }
  .echart-icon-color3 {
    display:inline-block;
    background:#6b96d6;
    width: 15px;
    height: 15px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 50%;
  }
  .app-rank {
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      justify-content: space-between;
      padding-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/Dashboard.vue